import React from "react";
import { Trash2, Plus } from "lucide-react";

function SaarcVisitFields({
  visits,
  onAdd,
  onRemove,
  onChange,
  dropdownData,
  readOnly,
  showWhen,
}) {
  // Don't show if saarc_visit is not "YES"
  if (!showWhen) return null;

  return (
    <div className="space-y-6">
      {visits.map((visit, index) => (
        <div
          key={visit.id}
          className="relative border border-gray-200 rounded-lg p-6 bg-gray-50"
        >
          {/* Remove button - only show if more than one entry */}
          {visits.length > 1 && !readOnly && (
            <button
              type="button"
              onClick={() => onRemove(visit.id)}
              className="absolute top-4 right-4 text-red-500 hover:text-red-700 transition-colors"
              title="Remove this visit"
            >
              <Trash2 size={20} />
            </button>
          )}

          <h4 className="text-sm font-semibold text-gray-700 mb-4">
            SAARC Visit #{index + 1}
          </h4>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* SAARC Country */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                SAARC Country
              </label>
              <select
                value={visit.saarc_country}
                onChange={(e) =>
                  onChange(visit.id, "saarc_country", e.target.value)
                }
                disabled={readOnly}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
              >
                <option value="">Select SAARC Country</option>
                {dropdownData?.saarc_country?.map((country) => (
                  <option key={country} value={country}>
                    {country}
                  </option>
                ))}
              </select>
            </div>

            {/* Year */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Year
              </label>
              <input
                type="text"
                value={visit.saarc_year}
                onChange={(e) =>
                  onChange(visit.id, "saarc_year", e.target.value)
                }
                disabled={readOnly}
                placeholder="e.g., 2023"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
              />
            </div>

            {/* Number of Visits */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Number of Visits
              </label>
              <input
                type="text"
                value={visit.no_of_visits}
                onChange={(e) =>
                  onChange(visit.id, "no_of_visits", e.target.value)
                }
                disabled={readOnly}
                placeholder="e.g., 2"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
              />
            </div>
          </div>
        </div>
      ))}

      {/* Add Another Visit Button */}
      {!readOnly && (
        <button
          type="button"
          onClick={onAdd}
          className="flex items-center gap-2 px-4 py-2 text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-50 transition-colors"
        >
          <Plus size={18} />
          Add Another SAARC Visit
        </button>
      )}
    </div>
  );
}

export default SaarcVisitFields;